import { dwCollect } from '@/utils/dw-collect';

/**
 * 工作区展示
 */
export const dwWorkbenchShow = () => {
  dwCollect({ module: 'work', action: 'show' });
};

//  切换工作区
export const dwToggleWorkbench = () => {
  dwCollect({ module: 'work', element: 'change', action: 'click' });
};

//  【创建工作区】展示
export const dwShowCreateWorkbench = () => {
  dwCollect({ module: 'work', element: 'add_work', action: 'show' });
};

//  点击【创建工作区】
export const dwClickCreateWorkbench = () => {
  dwCollect({ module: 'work', element: 'add_work', action: 'click' });
};

//  点击成员头像
export const dwClickMember = () => {
  dwCollect({ module: 'work', element: 'member', action: 'click' });
};

//  点击【添加成员】
export const dwClickAddMember = () => {
  dwCollect({ module: 'work', element: 'add_member', action: 'click' });
};

//  点击【升级人数】
export const dwClickUpgradeMember = () => {
  dwCollect({ module: 'work', element: 'upgrade_member', action: 'click' });
};

//  点击【立即升级】
export const dwClickPayNew = () => {
  dwCollect({ module: 'work', element: 'buy_plat', action: 'click' });
};

//  点击【续费】
export const dwClickPayRenew = () => {
  dwCollect({ module: 'work', element: 'renew_plat', action: 'click' });
};

//  点击【升级】
export const dwClickPayUpgrade = () => {
  dwCollect({ module: 'work', element: 'upgrade_plat', action: 'click' });
};

//  点击【增购配额】
export const dwClickPayQuota = () => {
  dwCollect({ module: 'work', element: 'quota', action: 'click' });
};

//  点击【全部工作区应用】
export const dwClickAllWork = () => {
  dwCollect({ module: 'work', element: 'all_work', action: 'click' });
};

// 点击【添加成员】
export const dwMemberAdd = () => {
  dwCollect({ module: 'member', element: 'add_member', action: 'click' });
};
// 点击【启用成员】
export const dwMemberEnable = () => {
  dwCollect({ module: 'member', element: 'enable_member', action: 'click' });
};
// 点击【禁用成员】
export const dwMemberDisable = () => {
  dwCollect({ module: 'member', element: 'disable_member', action: 'click' });
};
// 点击【移出工作区】
export const dwMemberDelete = () => {
  dwCollect({ module: 'member', element: 'delete_member', action: 'click' });
};
// 成员超限弹窗展示
export const dwMemberMaxTip = () => {
  dwCollect({ module: 'member', element: 'tip', action: 'show' });
};
// 点击【升级】
export const dwMemberUpgrade = () => {
  dwCollect({ module: 'member', element: 'upgrade_member', action: 'click' });
};
